import CardFeature from '~/components/Molecules/CardFeature/CardFeature.vue'

export default {
  props: {
    title: {
      type: String,
    },
    body: {
      type: String,
    },
    items: {
      type: Array,
    },
  },

  components: {
    hotCarousel: () => import('~/components/Molecules/Carousel/Carousel.vue'),
  },

  data() {
    return {
      cardFeature: CardFeature,

      swiperOptions: {
        slidesPerView: 1.1,
        spaceBetween: 16,
        allowTouchMove: true,
        breakpoints: {
          480: {
            slidesPerView: 1.1,
          },
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
            allowTouchMove: false,
          },
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },
    }
  },
}
